import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Axios install kar lein: npm install axios
import { Sidebar } from '../Sidebar';
import { Navbar } from '../../Navbar';
import config from '../../../config/config';

export default function ViewPayment() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${config.baseUrl}/api/payment/payments`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const stats = [
    { title: "Total Amount", value: data?.total_amt || "0", color: "bg-indigo-900" },
    { title: "Cash", value: data?.cash || "0", color: "bg-indigo-800" },
    { title: "cheque", value: data?.chq, color: "bg-indigo-700" }, // Agar ye DB mein hai to mapping kar dein
    { title: "Online", value: data?.online || "0", color: "bg-indigo-800" },
    { title: "Net Total", value: data?.net_amt || "0", color: "bg-indigo-900" },

  ];

  const collections = [
    { title: "Booking", value: data?.today_booking || "0", color: "bg-indigo-900" },
    { title: "Butcher", value: data?.today_butcher || "0", color: "bg-indigo-800" },
    { title: "Supplier", value: data?.today_supplier || "0", color: "bg-indigo-700" },
    { title: "Other Services", value: data?.today_other_service, color: "bg-indigo-600" },
    { title: "Expense", value: data?.today_expense || "0", color: "bg-indigo-600" },
    { title: "Other Income", value: data?.today_other_income || "0", color: "bg-indigo-700" },
    { title: "Refund", value: data?.refund || "0", color: "bg-indigo-800" },
  ];

  if (loading) return <div className="ml-60 pt-28 text-center font-bold">Loading Stats...</div>;

  return (
    <>
      <div>
        <h2 className="text-gray-600 text-sm font-semibold mb-4 border-b pb-2 uppercase tracking-wider">
          Today's Collections Summary
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2 mb-8">
        {stats.map((item, index) => (
          <div key={index} className={`${item.color} text-white p-8 rounded shadow-md text-center transition-transform hover:scale-105`}>
            <h3 className="text-xl font-medium mb-2">{item.title}</h3>
            <p className="text-4xl font-bold">{Number(item.value).toLocaleString()}</p>
          </div>
        ))}
      </div>

      {/* Middle Section: Collections & Payments */}
      <div className="mb-4">
        <h2 className="text-gray-600 text-sm font-semibold mb-4 border-b pb-2 uppercase tracking-wider">
          Today's Collections & Payments Details
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {collections.map((item, index) => (
            <div key={index} className={`${item.color} text-white p-8 rounded shadow-md text-center transition-transform hover:scale-105`}>
              <h3 className="text-xl font-medium mb-2">{item.title}</h3>
              <p className="text-4xl font-bold">{Number(item.value).toLocaleString()}</p>
            </div>
          ))}
        </div>
      </div>


    </>
  );
}